import { trace } from 'owa-trace';
import DoradoActionParameter, {
    SEARCH_ENTITY_TYPE,
    STRING_ENTITY_TYPE,
} from '../store/schema/DoradoActionParameter';

export default function getActionParametersForAction(
    action: any,
    entities: any[]
): DoradoActionParameter[] {
    const actionParameters: DoradoActionParameter[] = [];

    try {
        const bindings = JSON.parse(action.value.Payload.Bindings);
        Object.keys(bindings).forEach(key => {
            const binding = bindings[key];
            entities.forEach(entity => {
                if (entity.type === binding.Value.type) {
                    let actionParameter: DoradoActionParameter;
                    if (entity.type === SEARCH_ENTITY_TYPE || entity.type === STRING_ENTITY_TYPE) {
                        actionParameter = {
                            name: key,
                            type: entity.type,
                            value: undefined,
                            requiresUserInput: true,
                        };
                    }
                    if (actionParameter) {
                        actionParameters.push(actionParameter);
                    }
                }
            });
        });
    } catch (error) {
        trace.info('[CortanaCompose] getActionParametersForAction exception: ' + error.message);
    }

    return actionParameters;
}
